import { ConsentsState } from './ConsentsList/ConsentsList.types';

export enum ConsentSectionType {
  Required = 'required',
  Optional = 'optional',
  AgreeToAll = 'agreeAll',
}

export type ConsentsMapped = {
  [k: string]: LegalConsent[];
};

export type ConsentHeader = {
  forCountries?: string[];
  excludeCountries?: string[];
  forOptions?: string[];
  excludeOptions?: string[];
  headerContainerClassName?: string;
  headerContainerClassNameOverride?: string;
  header?: string;
  headerClassName?: string;
  headerClassNameOverride?: string;
  subHeader?: string;
  subHeaderClassName?: string;
  subHeaderClassNameOverride?: string;
  description?: string;
  descriptionClassName?: string;
  descriptionClassNameOverride?: string;
};

export type ConsentCheckbox = {
  forCountries?: string[];
  excludeCountries?: string[];
  forOptions?: string[];
  excludeOptions?: string[];
  id: string;
  isDisabled: boolean;
  isRequired: boolean;
  defaultChecked: boolean;
  showCheckbox: boolean;
  index: number;
  name: string;
  checkboxClassName?: string;
  checkboxClassNameOverride?: string;
  label: string;
  labelClassName?: string;
  labelClassNameOverride?: string;
  termsLink?: string;
  termsLinkLabel?: string;
  termsLinkClassName: string | string[];
  termsLinkTarget?: string;
  termsLinkClassNameOverride?: string;
  onError?: string;
  errorLabel: string;
  errorClassName?: string;
  errorClassNameOverride?: string;
  checked?: boolean;
};

export type LegalConsent = {
  id: string;
  name: string;
  countries: string[];
  options: string[];
  sectionType: ConsentSectionType;
  index: number;
  showTopDivider?: boolean;
  showBottomDivider?: boolean;
  containerClassName?: string;
  containerClassNameOverride?: string;
  onError?: string;
  errorClassName?: string;
  errorClassNameOverride?: string;
  headers?: ConsentHeader[];
  checkboxes: ConsentCheckbox[];
};

export interface OnConsentChangeParams {
  updatedConsentsList: LegalConsent[];
}

export type OnConsentChange = (params: OnConsentChangeParams) => void;

export interface LegalConsentsProps {
  consentsState: ConsentsState;
  local: string;
  countryCode: string;
  option: string;
  isValidateErrors: boolean;
}
